import { RequestResponse } from "../../DTO/requestResponse";
import { Request } from "../../CONSTANTS/request";
import { consultaTrackingDetalleDto } from "./consultaTrackingDetalle.dto";
import { MICROSERVICIOS } from "../../CONSTANTS/constants";
import * as ONLY from 'is-online';
import CheckVPN from "../../../SHARED/Check-VPN";


export default class Tracking {

    // Tracking.detalle
    static async detalle(detalle: consultaTrackingDetalleDto): Promise<RequestResponse> {

        if (await ONLY.default()) {

            if(await CheckVPN()){
            // if (true) {

                return new Request(MICROSERVICIOS.API_CRM).post("tracking/detalle", detalle);

            } else {
                return {
                    status: -2,
                    description: "No fue posible obtener información, No hay conexión con VPN",
                    data: null,
                    error: "No fue posible obtener información, No hay conexion con VPN",
                };


            }


        } else {
            return {
                status: -1,
                description: "No fue posible obtener información, No hay conexión a Internet",
                data: null,
                error: "No fue posible obtener información, No hay conexion a Internet",
            };
        }

    }


    // Tracking.DD
    static async DD(datos: any): Promise<RequestResponse> {

        let direccion = "DD/RecepcionDocumento/proceso_01"

        return new Request(MICROSERVICIOS.API_CRM).post(direccion, datos);

    }
}